import store from '@/store';

export const flashMessage = (message, type, nextPage) => {
	nextPage = nextPage || false;

	return store.dispatch('flashMessages/flashMessage', { message: message, type: type, nextPage: nextPage }, { root: true });
}

export const flashWarning = (message, nextPage) => flashMessage(message, 'warning', nextPage);
export const flashDanger = (message, nextPage) => flashMessage(message, 'danger', nextPage);
export const flashSuccess = (message, nextPage) => flashMessage(message, 'success', nextPage);
export const flashInfo = (message, nextPage) => flashMessage(message, 'info', nextPage);



// WEBPACK FOOTER //
// ./src/helpers/flash-message-helper.js